<template>
   <!-- page-wrapper Start-->
    <div class="page-wrapper">
        <div class="container-fluid">
            <!-- sign up page start-->
            <div class="authentication-main">
                <div class="row">
                    <div class="col-sm-12 p-0">
                        <div class="auth-innerright">
                            <div class="authentication-box">
                                <div class="card p-3">
                                    <div class=" d-flex flex-row justify-content-between ">
                                        <div>
                                            <feather @click="doLogin" class="text-back mt-4" type="arrow-left-circle"  size="30"></feather>                                            
                                        </div>
                                        <div>
                                            <div class="text-center"><img src="../assets/images/hor-th_100.png" alt=""></div>
                                            <span class="mb-3 text-center text-danger f-w-900" style="font-size: 16;">{{ $t('loginPage.hor-th') }} </span>                                             
                                        </div>
                                        <div class="mt-4" style="text-align: end"><LocaleSwitcher/></div>  
                                    </div>
                                    <h4 class="text-center">{{ $t('register.newUser') }}</h4>
                                    <h6 class="text-center text-info ">{{ $t('register.nameAndPassword') }}</h6>
                                    <form class="theme-form">
                                        <div class="form-group">
                                            <label for="name" class="col-form-label text-primary f-w-600">{{ $t('register.name') }}</label>
                                            <input class="form-control" id="name" v-model="name" type="text" :placeholder="$t('register.namePh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="phone" class="col-form-label text-primary f-w-600">{{ $t('register.phone') }}</label>
                                            <input class="form-control" id="phone" v-model="phone" type="text" :placeholder="$t('register.phonePh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="email" class="col-form-label text-primary f-w-600">{{ $t('register.email') }}</label>
                                            <input class="form-control" id="email" v-model="email" type="email" :placeholder="$t('register.emailPh')">
                                        </div>
                                        <div class="form-group">
                                            <label for="password" class="col-form-label text-primary f-w-600">{{ $t('register.password') }}</label>
                                            <input autocomplete="" class="form-control" id="password" v-model="password" type="password" :placeholder="$t('register.passwordPh')">
                                        </div>
                                        <!-- <div class="form-group">
                                            <div class="form-row">
                                                <div class="col-sm-6">
                                                    <label for="userCat" class="col-form-label text-primary pt-0 f-w-600">{{ $t('register.userCat') }}</label>
                                                    <b-form-select v-model="userCat" class="mb-3">
                                                        <b-form-select-option value="member">{{ $t('register.member') }}</b-form-select-option>
                                                        <b-form-select-option value="admin" disabled>{{ $t('register.admin') }}</b-form-select-option>
                                                        <b-form-select-option value="host" disabled>{{ $t('register.host') }}</b-form-select-option>
                                                    </b-form-select>
                                                </div>
                                            </div>
                                        </div>   -->
                                        <div class="form-row">
                                            <div class="col-sm-4">
                                                <button @click="signUp" class="btn btn-primary" type="button">{{ $t('register.signUp') }}</button>
                                            </div>
                                            <div class="col-sm-8">
                                                <div class="text-left mt-2 m-l-20">{{ $t('register.wasUser') }}  <a class="btn-link text-capitalize" href="/auth/login">{{ $t('register.login') }}</a></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- sign up page ends-->
        </div>
    </div>
    <!-- page-wrapper Ends-->
</template>

<script>
import { createUserWithEmailAndPassword } from 'firebase/auth'
import {getRandomInt} from "../utilities/util"
import {authUser,createNewUserWallet ,saveWithId} from "../firebase"
import LocaleSwitcher from "../components/localSwitcher.vue"
export default {
    components: { LocaleSwitcher },
    name: 'register',
    data() {
        return{
            userId: '',
            name : '',
            phone : '',
            userCat : 'member',
            email: '',
            password: '',
        }
    },
    methods: {
        signUp() {
            let msg = 'completed'
            const phoneRegex = /^\+?1?\s*\(?(\d{3})\)?[-.\s]?(\d{3})[-.\s]?(\d{4})$/
            const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g            
            if (this.name === ''){
                msg = this.$t("register.nameMsg")
            } else if (this.phone ===''){
                msg = this.$t("register.phoneMsg")
            } else if (!phoneRegex.test(this.phone)){
                msg = this.$t("register.phoneFormatMsg")                
            } else if (this.email ===''){
                msg = this.$t("register.emailMsg")
            } else if (!emailRegex.test(this.email)){
                msg = this.$t("register.emailFormatMsg")
            } else if (this.password ===''){
                msg =this.$t("register.passwordMsg")
            } else if (this.password.length < 8){
                msg = this.$t("register.passwordDigitMsg")
            } else if (this.userCat===''){
                msg = this.$t("register.userCatMsg")
            }  
            if (msg === 'completed'){
                createUserWithEmailAndPassword(authUser, this.email, this.password)
                .then( async(userCredential) => {
                    if (userCredential) {
                        let userId = `${getRandomInt(1000000 , 9000000)}`
                        let payload = {
                            uid: userCredential.user.uid,
                            userId : userId,
                            name: this.name,
                            phone:this.phone,
                            userCat: this.userCat,  
                            email: this.email,                                                      
                            ftName: this.name, 
                            dayBD: '',
                            monthBD: '',
                            yearBD: '',
                            timeBD: '',
                            estTime: '',
                            placeBD: '',                            
                            lrs: '',
                            
                        }
                        await saveWithId('Users', userId, payload).then(()=>{
                            this.$toasted.show(this.$t("register.successRegister") + this.email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});    
                            localStorage.setItem('user', this.email)
                            localStorage.setItem('userId', userId)
                            localStorage.setItem('userCat', this.userCat)
                            localStorage.setItem('name', this.name)
                            // this.$router.push('/'); 
                            switch (this.userCat) {
                                case 'member':
                                        setTimeout(function () {
                                            // window.location.href='/auth/setupLuck'  
                                            window.location.href='/process/lucking'  
                                        },500)                                         
                                        break;
                                    // case 'admin':
                                    //     setTimeout(function () {
                                    //         // window.location.href='/'  
                                    //         window.location.href='/process/refillOL' 
                                    //     },500)                                         
                                    //     break;
                                    // case 'host':
                                    //     setTimeout(function () {
                                    //         // window.location.href='/'
                                    //         window.location.href='/process/importCSV'  
                                    //     },500)                                         
                                    //     break;  
                                default:
                                    break;
                            }
                        })
                        await createNewUserWallet( 15 , userId)
                    }
                })
                .catch((error) => {
                    this.$toasted.show('Error...' + error.message, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 5000});
                });                                              
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        doLogin() {
            this.$router.push('/auth/login');
        },
    }
}
</script>
